import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImpresoraService {
  protected impresoraSeleccionada = new BehaviorSubject<number | null>(null);

  get impresoraSeleccionada$() {
    return this.impresoraSeleccionada.asObservable();
  }

  setImpresoraSeleccionada(impresoraId: number | null) {
    this.impresoraSeleccionada.next(impresoraId);
  }

  getImpresoraSeleccionada(): number | null {
    return this.impresoraSeleccionada.getValue();
  }
}
